import { padStart, range } from "lodash"
import { CCUtils } from "./CCUtils"

export class TimeUtils {
    static convertSecondsToTimer = (seconds: number) => {
        const minutes = Math.floor(seconds / 60)
        const secondsRemainder = seconds % 60
        const padZeroes = (num: number) => padStart(num.toString(), 2, "0")
        return `${padZeroes(minutes)}:${padZeroes(secondsRemainder)}`
    }

    static monthNumber = (month: Month) => CCUtils.enumValues(Month).indexOf(month) + 1

    static birthMonthAndDayToBirthCode = (birthMonth: Month, birthDay: number) => {
        return TimeUtils.monthNumber(birthMonth).toString().padStart(2, "0") + birthDay.toString().padStart(2, "0")
    }
}

export enum Month {
    JANUARY = "January",
    FEBRUARY = "February",
    MARCH = "March",
    APRIL = "April",
    MAY = "May",
    JUNE = "June",
    JULY = "July",
    AUGUST = "August",
    SEPTEMBER = "September",
    OCTOBER = "October",
    NOVEMBER = "November",
    DECEMBER = "December"
}

export type MonthMaybe = Month | ""

export const dayNumbers = range(1, 32)
